// eslint-disable-next-line deprecation/deprecation
export { Tabs, type TabsProps } from './Tabs';
import { tabsClasses as muiTabsClasses } from '@mui/material/Tabs';

/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system. Use `TabContext` instead.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export const tabsClasses = muiTabsClasses;
